// Shared with next.config.ts: every generated optimizer request must be allowed.
// Keep the existing Next widths for local images; these extra widths cover our
// article slots at up to 2x without generating an unbounded set of transforms.
export const lcpImageWidths = [370, 480, 640, 750, 832, 960, 1134, 1280, 1620, 1920, 2000, 2268, 2492]
// Match Storyblok's five-point image_quality steps, including Next's default 75.
// Next accepts at most 20 qualities and requires each to be between 1 and 100.
export const lcpImageQualities = Array.from({ length: 20 }, (_, index) => (index + 1) * 5)

export const lcpImageConfig = {
  deviceSizes: [...new Set([640, 750, 828, 1080, 1200, 1920, 2048, 3840, ...lcpImageWidths])].sort((a, b) => a - b),
  qualities: lcpImageQualities,
  // YouTube can replace a thumbnail at the same URL. Retain Next's four-hour
  // minimum rather than treating remote source URLs as immutable content.
  minimumCacheTTL: 14_400,
  maximumRedirects: 0,
  remotePatterns: [
    { protocol: 'https' as const, hostname: 'a.storyblok.com', port: '', pathname: '/f/45415/**', search: '' },
    { protocol: 'https' as const, hostname: 'i.ytimg.com', port: '', pathname: '/vi/**', search: '' },
    { protocol: 'https' as const, hostname: 'i.ytimg.com', port: '', pathname: '/vi_webp/**', search: '' },
  ],
}
